import h from "styled-components";
const x = h.div(
  ({
    theme: s,
    $renderAs: f,
    $color: n,
    $align: c = "left",
    $width: t,
    $widthX: o,
    $marginBottom: e,
    $marginBottomX: i,
    $alignSelf: l,
    $opacity: y = 1,
    $inline: u,
    $textDecoration: p
  }) => {
    const { text: m, colors: r, layout: $ } = s, {
      fontFamily: b,
      fontSize: g,
      lineHeight: d,
      letterSpacing: a,
      textTransform: T = "none"
    } = m[f];
    return `
      display: ${u ? "inline-block" : "block"};
      font-family: ${b};
      font-size: ${g}px;
      text-align: ${c};
      line-height: ${d}px;
      text-transform: ${T};
      ${typeof a == "number" ? `letter-spacing: ${a}px;` : ""}
      color: ${n ? r[n] : r.BLACK};
      opacity: ${y};
      width: ${t ? `${t}` : "auto"}${typeof t == "number" ? "px" : ""};
      ${o ? `width: ${o * $.gutter}px;` : ""}
      margin-bottom: ${e ? `${e}` : "initial"}${typeof e == "number" ? "px" : ""};
      ${i ? `margin-bottom: ${i * $.gutter}px;` : ""}
      ${l ? `align-self: ${l};` : ""}
      ${p ? `text-decoration: ${p};` : ""}
    `;
  }
);
x.displayName = "Text";
const z = x;
export {
  z as default
};
//# sourceMappingURL=text.js.map
